export const onSlackEvent = /* GraphQL */ `
  subscription OnSlackEvent($channelId: String) {
    onSlackEvent(channelId: $channelId) {
      type
      channel
      channelId
      user
      userImage
      text
      ts
      eventType
      thread_ts
      originalText
      additionalData
      parentTS
      parentText
      parentUserImage
      parentUserName
    }
  }
`;
